module.exports = __webpack_public_path__ + "img/educational-qualifications.f05c007d.svg";